import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7370694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bind-code-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "即将打开小程序")
], -1))

import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import ActivityDialog from './components/activity-dialog.vue'
import { showNormalToast } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'middle-wrap',
  setup(__props) {

const $route = useRoute()
const url = decodeURIComponent(($route.query.url as string) || '')

console.log('url', url)

function openMiniPrograme() {
  if (url) {
    window.location.href = url
  } else {
    showNormalToast('打开失败,无对应链接')
  }
}

onMounted(() => {
  openMiniPrograme()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ActivityDialog, {
      show: true,
      notedText: "打开",
      onNotedTextClick: openMiniPrograme,
      type: 2
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})